import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { InsertOption } from '../_models/insert.model';

import { ApiMsService, ApiMsServices } from 'app/_core/services/api-ms.service';
import { UserService } from 'app/_core/services/user.service';

@Injectable()
export class ContractService {
  dataFile: any;
  data: any;
  documentBase64: any;

  constructor(
    private readonly apiMsService: ApiMsService,
    protected userService: UserService
  ) {}

  getList(): Observable<any> {
    return this.apiMsService.call<any>(ApiMsServices.Comercializadores, `document/get-unified-list`, {
      retailerUniqueCode: this.userService.getRetailerUniqueCode(),
    });
  }

  downloadDocument(doc: any): Observable<any> {
    const url = doc.filter !== 'Communication' ? 'document/get' : 'communication/get';

    return this.apiMsService.call<any>(ApiMsServices.Comercializadores, url, {
      uuid: doc.uuid,
    });
  }

  insertDocument(doc: InsertOption, type: string): Observable<any> {
    const url = type !== 'communication' ? 'document/add' : 'communication/add';

    return this.apiMsService.call<any>(ApiMsServices.Comercializadores, url, {
      title: doc.title,
      contents: doc.contents,
      filename: doc.filename,
      timelineDate: doc.timelineDate,
    });
  }

  changeStatusDocument(args: any): Observable<any> {
    return this.apiMsService.call<any>(ApiMsServices.Comercializadores, 'document/change-status', args);
  }

  updateDocumment(args: any): Observable<any> {
    return this.apiMsService.call<any>(ApiMsServices.Comercializadores, 'document/update', {
      uuid: args.uuid,
      contents: args.contents,
      filename: args.filename,
      timelineDate: args.timelineDate,
    });
  }
}
